import { Accordion, Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { JointNominee } from './JointNominee';
import './JointNomineesSection.scss';

const JointNomineesSectionImpl: React.FC = () => {
  const {
    nominationWizardPageUiStore,
  } = useStores();

  return (
    <div
      className='joint-nominees-section'
    >
      {
        nominationWizardPageUiStore.nomination.award.allowJointNomination ?
          <>
            {
              nominationWizardPageUiStore.nomination.jointNominees.length === 0 &&
              <Text
                as='p'
                italic
                block
              >
                If you are not submitting as a joint nomination, please skip and continue.
              </Text>
            }
            <Accordion<string>
              collapsible
              multiple
              openItems={nominationWizardPageUiStore.expandedJointNomineeKeys}
              onToggle={(_, data) => {
                if (!data.openItems.includes((data.value))) {
                  nominationWizardPageUiStore.collapseJointNominee(data.value);
                } else {
                  nominationWizardPageUiStore.expandJointNominee(data.value);
                }
              }}
            >
              {
                nominationWizardPageUiStore.nomination.jointNominees.map((jointNominee, jointNomineeIndex) => {
                  const rowKey = nominationWizardPageUiStore.jointNomineeRowKeys[jointNomineeIndex];

                  return (
                    <JointNominee
                      key={rowKey}
                      rowKey={rowKey}
                      jointNomineeIndex={jointNomineeIndex}
                      onRemoveNominee={() => nominationWizardPageUiStore.removeJointNominee(jointNomineeIndex)}
                      organization={jointNominee}
                    />
                  );
                })
              }
            </Accordion>
          </>
          :
          <Text
            as='p'
            italic
            block
          >
            Joint nominees are not allowed for this award.
          </Text>
      }
    </div>
  );
  };

export const JointNomineesSection = observer(JointNomineesSectionImpl);
